import { useQueryClient } from "react-query";
import { replacePolishChars } from "../slide-menu/SlideMenu.utils";

export const modelPath = (model: any): string =>
  replacePolishChars(model.name.toLowerCase().replace(/ /g, "-"));

export const useModels = (): any[] => {
  const queryClient = useQueryClient();
  const models: any = queryClient.getQueryData(["/models"]);
  return Array.isArray(models) ? models : [];
};

// Path of the model that renders the tasks subpage, if such a model exists.
export const useTasksModelPath = (): string | null => {
  const tasksModel = useModels().find(
    (m: any) => m.subpage_type === "tasks"
  );
  return tasksModel ? modelPath(tasksModel) : null;
};
